import React from "react";
import "./style.scss";
import { MdArrowBackIosNew } from "react-icons/md";
import { useTranslation } from "react-i18next";

interface IProps {
  backFunction: () => void;
  title: string;
}

const MobilePageHeader: React.FC<IProps> = ({ backFunction, title }) => {
  const { t } = useTranslation();
  return (
    <div className="modal-window-header flex-start-center">
      <button
        onClick={() => {
          backFunction();
        }}
        className="back-button flex-start-center"
      >
        <MdArrowBackIosNew className="back-button-icon" />
        <b>{t("wroc")}</b>
      </button>

      <h1>{title}</h1>
    </div>
  );
};

export default MobilePageHeader;
